import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#2D3436] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                <span className="text-xl text-white font-bold">T</span>
              </div>
              <div>
                <h3 className="text-lg font-heading font-semibold">Tricity Ayurveda</h3>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Ancient wisdom meets modern healing. Your trusted partner for holistic Ayurvedic care.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <Link to="/doctors" className="text-sm text-gray-400 hover:text-primary transition-colors block">
                Our Doctors
              </Link>
              <Link to="/consultation" className="text-sm text-gray-400 hover:text-primary transition-colors block">
                Consultation
              </Link>
              <Link to="/services" className="text-sm text-gray-400 hover:text-primary transition-colors block">
                Services
              </Link>
              <Link to="/reviews" className="text-sm text-gray-400 hover:text-primary transition-colors block">
                Reviews
              </Link>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-sm text-gray-400">
                <Phone size={16} className="text-primary" />
                <span>+91 82950 80493</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-gray-400">
                <Phone size={16} className="text-primary" />
                <span>+91 81999 37841</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-gray-400">
                <Mail size={16} className="text-primary" />
                <a href="mailto:tricityayurveda@gmail.com" className="hover:text-primary transition-colors">
                  tricityayurveda@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-2 text-sm text-gray-400">
                <MapPin size={16} className="text-primary mt-1" />
                <span>Tricity Area, Chandigarh</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold mb-4">Follow Us</h4>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/tricity_ayurveda?igsh=MWR6ampuY2wwY3dhYw==" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-primary/20 rounded-full flex items-center justify-center hover:bg-primary transition-colors" aria-label="Instagram">
                <Instagram size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} Tricity Ayurveda Clinic. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}